import React from "react";
import { ExtraFeesSortTypes } from "../../../configs/sortTypes";
import { ExtraFeesFilterType } from "../../../configs/filterTypes";
import { ExtraFeeRow } from "./ExtraFeeTable";
import ListView from "../../../shared/components/ListView";
import { TableColumns, Search } from "../../../configs/extrafees";

const Content = () => {
    return (
        <ListView
            url="/extrafees/"
            sortTypes={ExtraFeesSortTypes}
            filterTypes={ExtraFeesFilterType}
            rowElement={ExtraFeeRow}
            tableColumns={TableColumns}
            textString={Search.searchText}
        />
    );
};

export default Content;
